import React, { FC } from "react";
import { Box, Button, Divider } from "@chakra-ui/react";
import { LeadTypeTag } from "components";
import { TLead } from "types/lead.type";
import { getLeadTypeLabel } from "utils/lead-type.utils";
import { formatGrsPendingLeadName } from "utils/grs-pending-leads.utils";

interface IGrsPendingLeadAcceptedStepProps {
  acceptedLead: TLead;
  closePrompt: () => void;
}

export const GrsPendingLeadAcceptedStep: FC<IGrsPendingLeadAcceptedStepProps> = ({
  acceptedLead,
  closePrompt,
}) => {
  const { type, person, address, postcode } = acceptedLead;
  const leadName = formatGrsPendingLeadName(person);
  const contactLine = [person.email, person.phone].filter(Boolean).join(", ");
  const addressLine = [address, postcode].filter(Boolean).join(", ");

  return (
    <Box>
      <Box mb={5} color={"leadpro.700"}>
        A new {getLeadTypeLabel(type).toLowerCase()} lead has been created on
        your dashboard. Close this dialog to view it on your dashboard.
      </Box>
      <Box display={"flex"} alignItems={"center"} mb={2}>
        <LeadTypeTag type={type} />
        <Box ml={3} color={"leadpro.700"}>
          <Box as={"span"} fontWeight={"bold"}>
            {leadName}
          </Box>
          {!!contactLine && `, ${contactLine}`}
        </Box>
      </Box>
      {!!addressLine && (
        <Box color={"leadpro.700"} mb={4}>
          {addressLine}
        </Box>
      )}
      <Divider mb={4} />
      <Box display={"flex"} justifyContent={"flex-end"}>
        <Button colorScheme={"blue"} onClick={closePrompt}>
          Close
        </Button>
      </Box>
    </Box>
  );
};
